

export const useCustomCellRenderers = (
  handleEditClick: any,Ballot:string[]
) => {
  const caseRenderers = {
    // actionCellRenderers: function (param: any) {
    //   return (
    //     <>
    //       {/* <div className="pad-r-10">
    //         <MotifButton
    //           size="small"
    //           variant="primary"
    //         >
    //           <MotifIcon
    //             iconFunction={IconoirTrash}
    //             stroke="blue"
    //             strokeWidth="2"
    //             size="24"
    //           />
    //         </MotifButton>
    //       </div> */}
    //       {/* {havingEditPermission(Ballot) &&<Link to={`./voting/edit/` + param.data.id}>
    //         <MotifButton
    //           onClick={() => {
    //             // setShowModal(true);
    //             // setActiveClaim(param.data.totalNumberOfClaims);
    //             // setDebtorId(param.data.id);
    //             handleEditClick();
    //           }}
    //           size="small"
    //           type="submit"
    //           variant="primary"
    //           // disabled={param.data.isActive == true ? false : true}
    //         >
    //           <MotifIcon
    //             iconFunction={IconoirEditPencil}
    //             // fill="#2E2E38"
    //             stroke="blue"
    //             strokeWidth="2"
    //             size="24"
    //           />
    //         </MotifButton>
    //       </Link>
    // } */}
    //     </>
    //   );
    // },
  };
  return caseRenderers;
};
